import { generateClient } from 'aws-amplify/api';

const client = generateClient();

// Direct DynamoDB operations without User relationship
export const watchlistService = {
  async createWatchlist(input) {
    const mutation = `
      mutation CreateUserWatchlistDirect($input: CreateUserWatchlistInput!) {
        createUserWatchlist(input: $input) {
          id
          userID
          name
          description
          isDefault
          isPublic
          itemCount
          createdAt
          updatedAt
          __typename
        }
      }
    `;
    
    const result = await client.graphql({
      query: mutation,
      variables: { input }
    });
    
    return result.data.createUserWatchlist;
  },

  async updateWatchlist(input) {
    const mutation = `
      mutation UpdateUserWatchlistDirect($input: UpdateUserWatchlistInput!) {
        updateUserWatchlist(input: $input) {
          id
          userID
          name
          description
          isDefault
          isPublic
          itemCount
          createdAt
          updatedAt
          __typename
        }
      }
    `;
    
    const result = await client.graphql({
      query: mutation,
      variables: { input }
    });
    
    return result.data.updateUserWatchlist;
  },

  async deleteWatchlist(id) {
    const mutation = `
      mutation DeleteUserWatchlistDirect($input: DeleteUserWatchlistInput!) {
        deleteUserWatchlist(input: $input) {
          id
          __typename
        }
      }
    `;
    
    const result = await client.graphql({
      query: mutation,
      variables: { input: { id } }
    });
    
    return result.data.deleteUserWatchlist;
  }
};